export enum TypeClockInReports {
    DAILY       = 'daily',
    WEEKLY      = 'weekly',
    MONTHLY     = 'monthly',
}

export enum ColumnType {
    CLOCKED_IN_HOURS        = "Clocked-in hours",
    REQUIRED_HOURS          = "Required hours",
    WORKDAYS                = "Workdays",
    OFF_DAYS                = "Off-days",
    COLOR_CODING            = "Color coding"
}

export const InitialShowColumnOption = [
    {
        label: ColumnType.CLOCKED_IN_HOURS,
        value: true
    },
    {
        label: ColumnType.REQUIRED_HOURS,
        value: false
    },
    {
        label: ColumnType.WORKDAYS,
        value: false
    },
    {
        label: ColumnType.OFF_DAYS,
        value: false
    },
    {
        label: ColumnType.COLOR_CODING,
        value: false
    },
]
